import React from "react";
import _ from "lodash";
import Socket from "socket";
import logo from "assets/images/say-what/saywhat-logo.png";

const BeforeCaptionSubmit = ({
  photo,
  roomId,
  caption,
  mobile_app,
  set_caption,
  cc_countdown,
  currentPlayer,
  showcase_params
}) => {
  const top_label = _.get(showcase_params, "top_label", "Caption this!");
  const caption_label = _.get(
    showcase_params,
    "caption_label",
    "Give it a funny caption:"
  );
  const time_label = _.get(showcase_params, "time_label", "Time Remaining:");
  const submit_button = _.get(showcase_params, "submit_button", "SUBMIT");

  const handleCaptionSubmit = () => {
    if (mobile_app) {
      const message = {
        action: "submit-caption",
        playerId: currentPlayer?.player_id,
        caption
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "submit-caption",
        roomId,
        playerId: currentPlayer?.player_id,
        caption
      };
      Socket.sendMessage(data);
    }
    setTimeout(() => {
      set_caption("");
    }, 2000);
  };

  return (
    <div className={`caption-this ${mobile_app ? "mobile-cnt" : "web-cnt"}`}>
      <div className="caption-div">
        <img src={logo} className="sw-logo" alt="logo" />
        <p className="waiting-txt">{top_label}</p>
        <img src={photo} className="caption-img" alt="logo" />
        <p className="give">{caption_label}</p>
        <input
          rows="1"
          type="text"
          value={caption}
          className="caption"
          placeholder="Enter Caption"
          onChange={(e) => set_caption(e.target.value)}
        />
      </div>
      <div className="caption-submit">
        <p className="time">{time_label}</p>
        <p className="seconds">{cc_countdown} Seconds</p>
      </div>
      <button
        onClick={handleCaptionSubmit}
        disabled={cc_countdown === 0 ? true : false}
        className={`${cc_countdown === 0 ? "disabled-btn" : "submit-btn"}`}
      >
        {submit_button}
      </button>
    </div>
  );
};

export default BeforeCaptionSubmit;
